import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiFetch } from '../../modules/utility';

const apiBase = 'timeClockShift';

const managerClockIn = ({params = {}, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.manager.clockIn`,
			params,
			dispatch,
			callback,
			savingMessage: `Clocking in employee...`,
			savedMessage : `Employee clocked in successfully.`,
		});
	};
};

const managerClockOut = ({params = {}, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.manager.clockOut`,
			params,
			dispatch,
			callback,
			savingMessage: `Clocking out employee...`,
			savedMessage : `Employee clocked out successfully.`,
		});
	};
};

const managerAdd = ({params = {}, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.manager.add`,
			params,
			dispatch,
			callback,
			savingMessage: `Adding employee time shift...`,
			savedMessage : `Employee's shift successfully added.`,
		});
	};
};

const managerUpdate = ({params = {}, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.manager.update`,
			params,
			dispatch,
			callback,
			savingMessage: `Updating employee time shift...`,
			savedMessage : `Employee's shift successfully updated.`,
		});
	};
};

const managerRemove = ({params = {}, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.manager.remove`,
			params,
			dispatch,
			callback,
			savingMessage: `Removing employee time shift...`,
			savedMessage : `Employee's shift successfully removed.`,
		});
	};
};

const managerSearch = ({params = {}, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.manager.search`,
			params,
			dispatch,
			callback,
		});
	};
};

const exponentExport = ({params = {}, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.manager.exponentExport`,
			params,
			dispatch,
			callback,
		});
	};
};


const mapStateToProps = (state) => {
	const newState = {};
	newState.userMap = state.maps.user;
	return newState;
};

const mapDispatchToProps = dispatch => bindActionCreators({
	timeClockShiftManagerClockIn : managerClockIn,
	timeClockShiftManagerClockOut : managerClockOut,
	timeClockShiftManagerAdd : managerAdd,
	timeClockShiftManagerUpdate : managerUpdate,
	timeClockShiftManagerRemove : managerRemove,
	timeClockShiftManagerSearch : managerSearch,
	timeClockShiftExponentExport : exponentExport,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
